/**
 * @generated SignedSource<<c166780ce0c188a56f34297bbe5cfb4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeScheduleSettingsQuery_store$data = {
  readonly myRole: Roles;
  readonly publicTeams: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TeamSelectList_Team">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"ManageEmployeeSchedueTypesListItem_store">;
  readonly " $fragmentType": "WidgetEmployeeScheduleSettingsQuery_store";
};
export type WidgetEmployeeScheduleSettingsQuery_store$key = {
  readonly " $data"?: WidgetEmployeeScheduleSettingsQuery_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleSettingsQuery_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeScheduleSettingsQuery_store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "myRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "publicTeams",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamSelectList_Team"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ManageEmployeeSchedueTypesListItem_store"
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "00b5cc99dc8cfb8a63c4e45d0b78a113";

export default node;
